import React from 'react';
import InstitutionLogo from './InstitutionLogo';
import StarBorder from './StarBorder';

const Experience = () => {
    const entries = [
        {
            logo: '/images/sierrraattahoelogo.png',
            logoAlt: 'Logotipo de Sierra-at-Tahoe Resort',
            fallback: 'ST',
            role: 'Food Service Worker',
            org: 'Sierra-at-Tahoe Resort · Jornada completa',
            dates: 'dic. 2025 – mar. 2026 · 4 meses',
            location: 'California, United States · Presencial',
            skills: null
        },
        {
            logo: '/images/sierrraattahoelogo.png',
            logoAlt: 'Logotipo de Sierra-at-Tahoe Resort',
            fallback: 'ST',
            role: 'Ski Instructor',
            org: 'Sierra-at-Tahoe Resort · Jornada completa',
            dates: 'dic. 2024 – mar. 2025 · 4 meses',
            location: 'California, United States · Presencial',
            skills: 'Teaching y English'
        },
        {
            logo: '/images/logouca.png',
            logoAlt: 'Logotipo de UCASPA',
            fallback: 'UC',
            role: 'Práctica operaria',
            org: 'UCASPA · Práctica',
            dates: 'ene. 2024 · 1 mes',
            location: 'Chile · Presencial',
            skills: null
        }
    ];

    return (
        <section id="experience" className="experience-section">
            <span className="section-heading__accent text-center d-block">Trayectoria</span>
            <h2 className="section-heading">Experiencia</h2>
            <div className="row justify-content-center mt-4">
                <div className="col-12 col-lg-10 col-xl-9">
                    {entries.map((job, index) => (
                        <div key={index} className="education-item mb-4">
                            <StarBorder
                                as="div"
                                block
                                innerClassName="lg-glass education-entry education-entry--experience"
                                color="rgba(126, 189, 203, 0.32)"
                                speed="12s"
                            >
                                <InstitutionLogo
                                    src={job.logo}
                                    alt={job.logoAlt}
                                    fallback={job.fallback}
                                />
                                <div className="education-entry__body">
                                    <h3 className="education-entry__school">{job.role}</h3>
                                    <p className="education-entry__degree mb-0">{job.org}</p>
                                    <p className="education-entry__dates mb-0">{job.dates}</p>
                                    <p className="education-entry__dates mb-0">{job.location}</p>
                                    {job.skills ? (
                                        <p className="education-entry__meta mb-0">{job.skills}</p>
                                    ) : null}
                                </div>
                            </StarBorder>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
